import {useMemo} from "react";
import {useMeetingRoomList} from "../useMeetingRoomList";

export function useMeetingRoomListSingleRoom(roomId: string) {
    const roomIdArray = useMemo(() => {
        return [roomId];
    }, [roomId]);
    return useMeetingRoomList(roomIdArray);
}